"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_localize_redux_1 = require("react-localize-redux");
var react_redux_1 = require("react-redux");
var getYouwellTranslate = function (store) { return function (translationKey, data, options) { return (0, react_localize_redux_1.getTranslate)(store.localize)(translationKey, data, options).toString(); }; };
var useYouwellTranslate = function () { return (0, react_redux_1.useSelector)(getYouwellTranslate); };
exports.default = useYouwellTranslate;
